import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  background-color: ${(props) => props.theme.colors.component};
  z-index: 999999;
  overflow-y: auto;

  .input-label {
    display: block;
    margin-bottom: 20px;
    color: ${(props) => props.theme.colors.modalTitleColor};
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 16px;
  }

`;

export const Header = styled.div`
  display: flex;
  padding: 20px 20px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.theme.colors.backgroundColorHeader};

  .locationName {
    display: flex;
    margin: 26.5px 0 0 63px;
    color: ${(props) => props.theme.colors.text.default};
    font-size: 14px;
    line-height: 16px;
    font-variant: small-caps;

    span:first-child {
      cursor: pointer;
    }

    .specificLocation {
      font-weight: 700;
    }

  .svgWrapper {
    margin: 0 12px;
    display: flex;
    align-items: center;

    .arrow {
      transform: rotate(90deg);
    }
  }

  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
  padding: 14px 60px 16px 60px;
`;

export const Title = styled.h1`
  display: flex;
  font-size: 20px;
  line-height: 23px;
  margin: 0 0 0 63px !important;
  font-weight: 700;
  align-items: center;
  color: ${(props) => props.theme.colors.text.default} !important;
  padding-bottom: 14.5px;
  border-bottom: 1px solid ${(props) => props.theme.colors.component};

  .icon-wrapper {
    
    margin-right: 13px;
    display: flex;
    align-items: center;
    
    .icon {
      fill: ${(props) => props.theme.colors.text.default} !important;
      width: 18px;
      height: 18px;
    }
  }
`;

export const Body = styled.div`
  color: ${(props) => props.theme.colors.text.default};
  padding: 20px 20px;
  display: flex;
  margin-bottom: ${({footerVisibility}) => footerVisibility ? '50px' : 0};
  align-items: inherit;
  width: 100%;
  justify-content: center;
  .inputsearch {
    height: 35px;
  }
  ::-webkit-scrollbar{
    visibility: hidden;
    width: 0px;
  }
`;

export const Actions = styled.div`
  padding: 20px 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

// Estilo referente ao footer de combinação de perguntas
export const CombineQuestions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 36px;
  height: 84px;
  background-color: ${(props) => props.theme.colors.highLight};
  width: 100%;
  padding: 20px 0;
  position: fixed;
  left: 0;
  bottom: 0;
  color: ${(props) => props.theme.colors.text.default};
  z-index: 99;

  p {
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: ${(props) => props.theme.colors.secondary};
  }

  span {
    height: 39px;
    width: 1px;
    background-color: ${(props) => props.theme.colors.text.placeholder};
    display: block;
  }
`

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
  height: 39px;
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.colors.text.default};
  border-radius: 4px;
  cursor: pointer;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text.default};
  svg {
      fill: ${(props) => props.theme.colors.text.default};
      path {
        fill: ${(props) => props.theme.colors.text.default};
      }
    }

  :hover {
    background-color: ${(props) => props.theme.colors.component};
    color: ${(props) => props.theme.colors.text.default};
    border: none;
  }

  :disabled {
    background-color: ${(props) => props.theme.colors.details};
    color: ${(props) => props.theme.colors.component};
    border: none;
    cursor: not-allowed;
    svg {
      fill: ${(props) => props.theme.colors.component};
      path {
        fill: ${(props) => props.theme.colors.component};
      }
    }
  }
`

export const CombineButton = styled(SendButton)`

  background-color: ${(props) => props.theme.colors.backgroundItemColor};
  border: none;

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.colors.EvolutivevOkButtonColor};
    opacity: 0.8;
  }  
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${(props) => (props.contentHeight ? props.contentHeight : '450px')};
`;
